import { openPlanDialogQueryKey } from './_constants';
import { getClusterIdFromLink } from '../routingUtils';
import {
  RebalancePlanReportTabs,
  RebalancingPlanCreationSubRoutes,
} from './_types';

type RebalancingUrlPropsBase = {
  clusterId?: string;
};

type RebalancingListUrlProps = RebalancingUrlPropsBase & { openPlan?: string };

export const getRebalancingPlanListLink = ({
  clusterId = getClusterIdFromLink(),
  openPlan,
}: RebalancingListUrlProps = {}): string => {
  if (!clusterId) {
    console.error('Cluster id does not exist in path');
  }
  return `/external-clusters/${clusterId}/rebalance/list${
    openPlan ? `/log?${openPlanDialogQueryKey}=${openPlan}` : ''
  }`;
};

type RebalancingPlanWizardProps = RebalancingUrlPropsBase & { planId: string };

type RebalancingPlanReportProps = RebalancingUrlPropsBase & {
  planId: string;
  tab?: RebalancePlanReportTabs;
};

const getRebalancingPlanWizardLink = ({
  clusterId = getClusterIdFromLink(),
  planId,
}: RebalancingPlanWizardProps): string => {
  return `/external-clusters/${clusterId}/rebalance/${planId}`;
};

export const getRebalancingPlanReviewLink = (
  linkProps: RebalancingPlanWizardProps
): string => {
  return `${getRebalancingPlanWizardLink(linkProps)}/plan`;
};

type RebalancingPlanReviewProps = RebalancingUrlPropsBase & { planId: string };

export const getRebalancingPlanReviewLinkV2 = ({
  clusterId = getClusterIdFromLink(),
  planId,
}: RebalancingPlanReviewProps): string => {
  return `/external-clusters/${clusterId}/rebalance/${planId}/${RebalancingPlanCreationSubRoutes.REVIEW}`;
};

export const getRebalancingPlanProgressLink = (
  linkProps: RebalancingPlanWizardProps
): string => {
  return `${getRebalancingPlanWizardLink(linkProps)}/progress`;
};

export const getRebalancingPlanReportLink = ({
  clusterId = getClusterIdFromLink(),
  planId,
  tab = RebalancePlanReportTabs.ACHIEVED,
}: RebalancingPlanReportProps): string => {
  return `/external-clusters/${clusterId}/rebalance/${planId}/report/${tab}`;
};

export const getRebalancerDashboardLink = ({
  clusterId = getClusterIdFromLink(),
}: RebalancingUrlPropsBase = {}): string => {
  return `/external-clusters/${clusterId}/rebalance/list`;
};

export const getPrepareNewPlanLink = ({
  clusterId = getClusterIdFromLink(),
}: RebalancingUrlPropsBase = {}): string => {
  return `/external-clusters/${clusterId}/rebalance/new`;
};

export const makeClusterScheduledRebalancerLink = ({
  clusterId = getClusterIdFromLink(),
}: RebalancingUrlPropsBase = {}): string => {
  return `/external-clusters/${clusterId}/rebalance/list/schedule`;
};
